module.exports = __webpack_public_path__ + "static/img/mobilestep4.44a43cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilestep4.png
// module id = /fm6
// module chunks = 1